import script from "./ErrorCompraMembresia.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorCompraMembresia.vue?vue&type=script&setup=true&lang=js"

import "./ErrorCompraMembresia.vue?vue&type=style&index=0&id=4668d9a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4668d9a6"]])

export default __exports__